import styled from 'styled-components';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label<{ theme: Theme }>`
  display: block;
  ${getBodyStyle('graphikCond', { default: 'default' })};

  span {
    color: ${getColor('textAccentSecondary')};

    &.disclaimer {
      color: ${getColor('textPrimary')}
    }
  }
`;

export const RadioOptions = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
